import { useLayoutEffect } from 'react';
import { useLogAnalyticsEvent } from 'shared/src/hooks';

/** 전체메뉴(SERVICE_MAP) 화면 진입 시 VIEW_SERVICE_MAP 발화. */
export const useLogViewServiceMap = () => {
  const logAnalyticsEvent = useLogAnalyticsEvent();

  useLayoutEffect(() => {
    logAnalyticsEvent({
      name: 'VIEW_SERVICE_MAP',
    });
  }, [logAnalyticsEvent]);
};
